import * as bootstrap from 'bootstrap'

export class UploadSearchModal {
  constructor(container, uploadUrl) {
    this.container = container;
    this.uploadUrl = uploadUrl;
    this.form = container.querySelector('#uploadSearchForm');
    this.fileInput = container.querySelector('#csvFileInput');
    this.submitBtn = container.querySelector('#uploadSubmitBtn');
    this.errorMessages = container.querySelector('#uploadErrorMessages');
    this.modal = container; // The container IS the modal element
    this.bootstrapModal = new bootstrap.Modal(this.modal);

    this.bindEvents();
  }

  bindEvents() {
    this.submitBtn.addEventListener('click', (e) => this.handleSubmit(e));
    this.modal.addEventListener('show.bs.modal', () => this.handleModalShow());
  }

  handleSubmit(e) {
    e.preventDefault();

    if (!this.fileInput.files || !this.fileInput.files[0]) {
      this.showError(this.getTranslation('upload_file_required', 'Please select a CSV file'));
      return;
    }

    const formData = new FormData();
    formData.append('file', this.fileInput.files[0]);

    this.submitBtn.disabled = true;
    this.submitBtn.innerHTML = `<span class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>${this.getTranslation('uploading', 'Uploading...')}`;

    fetch(this.uploadUrl, {
      method: 'POST',
      body: formData,
      headers: {
        'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]').content
      }
    })
      .then(response => {
        if (response.ok) {
          return response.json().then(() => {
            this.fileInput.value = '';
            this.bootstrapModal.hide();
            // Show flash message and reload
            location.reload();
          });
        } else {
          return response.json().then(data => {
            const errorMsg = data.errors
              ? data.errors.join('<br>')
              : this.getTranslation('upload_error', 'An error occurred during upload');
            this.showError(errorMsg);
            this.submitBtn.disabled = false;
            this.submitBtn.innerHTML = this.getTranslation('upload', 'Upload');
          });
        }
      })
      .catch(error => {
        const errorMsg = `${this.getTranslation('upload_error', 'An error occurred during upload')}: ${error.message}`;
        this.showError(errorMsg);
        this.submitBtn.disabled = false;
        this.submitBtn.innerHTML = this.getTranslation('upload', 'Upload');
      });
  }

  handleModalShow() {
    this.errorMessages.classList.add('d-none');
    this.errorMessages.innerHTML = '';
    this.fileInput.value = '';
    this.submitBtn.disabled = false;
    this.submitBtn.innerHTML = this.getTranslation('upload', 'Upload');
  }

  showError(message) {
    this.errorMessages.innerHTML = message;
    this.errorMessages.classList.remove('d-none');
  }

  getTranslation(key, defaultValue) {
    // Look for pre-rendered translation data in the DOM
    const translationElement = document.querySelector(`[data-translation-${key}]`);
    if (translationElement) {
      return translationElement.getAttribute(`data-translation-${key}`);
    }
    return defaultValue;
  }

  static initialize() {
    const container = document.querySelector('[data-upload-search-modal]');
    if (container) {
      const uploadUrl = container.getAttribute('data-upload-url');
      new UploadSearchModal(container, uploadUrl);
    }
  }
}

// Auto-initialize when DOM is ready or if already loaded
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', UploadSearchModal.initialize);
} else {
  UploadSearchModal.initialize();
}
